import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Row, Col, Table, Button, Modal, Spin, Card, Popconfirm, Pagination, Select, Checkbox } from 'antd'
import _ from 'underscore'
import { api, app, config } from '../../app'
import utils from '../../utils'
import common from './common'
import ReviewSearch from '../../components/ReviewSearch'

const Option = Select.Option

function checkAudit (audit) {
    switch (audit) {
        case '0':
            return '未审核'
        case '1':
            return '已通过'
        case '2':
            return '不通过'
    }
}

class ReNotice extends Component {
    constructor (props) {
        super(props)
        this.state = {
            detailInfo: {},
            reviewInfo: {},
            selectedRowKeys: [],
            auditList: [],
            total: 0,
            page: 1,
            dataType: '1',
            dataLevel: '0',
            search_type: 'searchform_name',
            search_val: '',
        }
    }

    componentDidMount () {
        this._isMounted = true
        this.dataSource()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 关闭详情弹框
     * @constructor
     */
    CloseDetailModal = () => {
        this.setData({ detail_visible: false })
    }

    /**
     * 打开详情弹框
     * @constructor
     */
    OpenDetailModal = async (id) => {
        await this.setData({ detail_visible: true, detail_loading: true })
        const params = {
            id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg } = await app.post(api.PublishMessagetDetails, params)
        let state = { detail_loading: false }
        if (flag === 1) {
            state.detailInfo = data
        } else {
            app.alert(msg, 'error')
        }
        this.setData(state)
    }

    /**
     * 页码修改
     * @param page
     */
    handlePageChange = async (page) => {
        await this.dataSource(page)
    }

    /**
     * 全选
     * @param e
     * @returns {Promise<void>}
     */
    handleAllSel = async (e) => {
        let checked = e.target.checked
        let selectedRowKeys = []
        if (checked) {
            selectedRowKeys = _.range(1, this.state.auditList.length + 1)
        }
        await this.setData({ selectedRowKeys })
    }

    /**
     * 批量审核
     * @param type
     */
    handlePLReview = async (type) => {
        let { selectedRowKeys, auditList, page, total } = this.state, len = selectedRowKeys.length
        if (len === 0) {
            app.alert('请选择审核内容', 'warn')
            return
        }
        let tp = parseInt((total - len) / 20)
        tp = (total - len) % 20 === 0 ? tp : tp + 1
        if (tp >= page) {
            tp = page
        }
        let id = selectedRowKeys.map(index => auditList[index - 1].id).join(',')
        let reviewInfo = {
            id,
            uri: api.PublishMessagetAudit,
            id_key: 'id',
            source: () => this.dataSource(tp),
        }
        if (type === 1) {
            this.props.successReview(1, '', reviewInfo)
        } else if (type === 2) {
            this.props.failReview(reviewInfo)
        }
    }

    /**
     * 搜索
     * @param search_type
     * @param search_val
     */
    handleSearch = async (search_type, search_val) => {
        await this.setData({ search_type, search_val })
        await this.dataSource()
    }

    /**
     * 数据源
     */
    dataSource = async (page = 1) => {
        await this.setData({ page, data_loading: true })
        let { dataType, search_type, search_val, dataLevel } = this.state, params = {
            page,
            search_val,
            search_type,
            type: dataType,
            level: dataLevel,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg, total } = await app.post(api.MessageAuditList, params)
        if (flag !== 1) {
            app.alert(msg, 'error')
            data = []
        }
        if (page === this.state.page) {
            await this.setData({
                selectedRowKeys: [],
                data_loading: false,
                auditList: utils.addArrayKey(data),
                total: parseInt(total || 0),
            })
        }
    }

    render () {
        let { data_loading, auditList, total, page, selectedRowKeys, dataType, detail_visible, detailInfo, detail_loading } = this.state,
            tp = parseInt((total - 1) / 20)
        tp = (total - 1) % 20 === 0 ? tp : tp + 1
        if (tp >= page) {
            tp = page
        }
        let columns = [
            {
                title: '标题',
                dataIndex: 'title',
                key: 'title',
                width: '15%',
                render: (title) => (
                    <span title={title}>{title.length > 20 ? title.substr(0, 20) + '...' : title}</span>)
            },
            {
                title: '级别',
                dataIndex: 'object',
                key: 'object',
                width: '8%'
            },
            {
                title: '发布对象',
                dataIndex: 'object_name',
                key: 'object_name',
                width: '12%'
            },
            {
                title: '发布时间',
                dataIndex: 'cteate_time',
                key: 'cteate_time',
                width: '12%'
            },
            {
                title: '发布人',
                dataIndex: 'vname',
                key: 'vname',
                width: '10%'
            },
            {
                title: '一级审核',
                dataIndex: 'one_audit',
                key: 'one_audit',
                width: '10%',
                render: (audit, { one_indexno, one_time, detail }) => common.tableStatus(audit, one_indexno, one_time, detail)
            },
            {
                title: '二级审核',
                dataIndex: 'two_audit',
                key: 'two_audit',
                width: '10%',
                render: (audit, { two_indexno, two_time, detail, object_type }) => {
                    if (object_type === '1') {
                        return common.tableStatus(audit, two_indexno, two_time, detail)
                    } else {
                        return (<span>无</span>)
                    }
                }
            },
            {
                title: '三级审核',
                dataIndex: 'three_audit',
                key: 'three_audit',
                width: '10%',
                render: (audit, { three_indexno, three_time, detail, object_type }) => {
                    if (object_type === '1') {
                        return common.tableStatus(audit, three_indexno, three_time, detail)
                    } else {
                        return (<span>无</span>)
                    }
                }
            }
        ], rowSelection = null
        if (dataType === '1') {
            rowSelection = {
                selectedRowKeys,
                onChange: async (selectedRowKeys) => {
                    await this.setData({ selectedRowKeys })
                }
            }
            columns.push({
                title: '操作',
                dataIndex: 'id',
                key: 'id',
                width: '10%',
                render: (id) => {
                    let reviewInfo = {
                        id,
                        uri: api.PublishMessagetAudit,
                        id_key: 'id',
                        source: () => this.dataSource(tp),
                    }
                    let disabled = selectedRowKeys.length > 1
                    return (
                        <div>
                            <div>
                                <Button size="small" type="primary" onClick={() => this.OpenDetailModal(id)}>详情</Button>
                            </div>
                            <div>
                                <Popconfirm placement="bottom"
                                            title="确定审核通过吗？"
                                            cancelText="取消"
                                            okText="确定"
                                            onConfirm={() => {
                                                this.props.successReview(1, '', reviewInfo)
                                            }}
                                >
                                    <Button size="small" type="primary" style={{ margin: '10px 0' }}>通过</Button>
                                </Popconfirm>
                            </div>
                            <div>
                                <Button size="small" type="danger" onClick={() => this.props.failReview(reviewInfo)}
                                        disabled={disabled} ghost>不通过</Button>
                            </div>
                        </div>
                    )
                }
            })
        } else {
            columns.push({
                title: '操作',
                dataIndex: 'id',
                key: 'id',
                width: '10%',
                render: (id) => {
                    return (
                        <Button size="small" type="primary" onClick={() => this.OpenDetailModal(id)}>详情</Button>
                    )
                }
            })
        }
        return (
            <div className="review-notice">
                <div>
                    <span>审核状态： </span>
                    <Select defaultValue="1" style={{ width: 120, marginBottom: 20 }} onChange={async (value) => {
                        await this.setData({ dataType: value })
                        await this.dataSource()
                    }}>
                        <Option value="1">未审核</Option>
                        <Option value="2">已审核</Option>
                    </Select>
                    <span style={{ marginLeft: 20 }}>级别选择： </span>
                    <Select defaultValue="0" style={{ width: 120, marginBottom: 20 }} onChange={async (value) => {
                        await this.setData({ dataLevel: value })
                        await this.dataSource()
                    }}>
                        <Option value="0">全部</Option>
                        <Option value="1">全国</Option>
                        <Option value="2">省级</Option>
                        <Option value="3">市级</Option>
                        <Option value="4">队伍</Option>
                    </Select>

                    <ReviewSearch type='message' onSearch={this.handleSearch}/>
                </div>
                <Table columns={columns}
                       locale={app.tbLocale(data_loading)}
                       loading={data_loading}
                       dataSource={auditList}
                       scroll={{ y: 'calc(100% - 103px)' }}
                       style={{ height: 'calc(100% - 52px)' }}
                       pagination={false}
                       rowSelection={rowSelection}
                       size="small"
                       footer={() => {
                           return (
                               <Row hidden={auditList.length === 0}>
                                   <Col span={10}>
                                       <div hidden={dataType === '2'}>
                                           <Checkbox
                                               checked={auditList.length !== 0 && auditList.length === selectedRowKeys.length}
                                               onChange={this.handleAllSel}>全选</Checkbox>
                                           <Button style={{ margin: '0 20px' }} type="primary"
                                                   onClick={() => this.handlePLReview(1)}>通过</Button>
                                           <Button type="danger"
                                                   onClick={() => this.handlePLReview(2)}>不通过</Button>
                                       </div>
                                   </Col>
                                   <Col span={14} style={{ textAlign: 'right' }}>
                                       <Pagination total={total} size="small" pageSize={20} current={page}
                                                   showTotal={(total) => `总数量：${total}`}
                                                   onChange={this.handlePageChange}/>
                                   </Col>
                               </Row>
                           )
                       }}
                />
                <Modal
                    visible={detail_visible}
                    onCancel={this.CloseDetailModal}
                    footer={null}
                    title={<div style={{ textAlign: 'center' }}>通知详情</div>}
                    maskClosable={false}
                    width='80%'
                    createrd={true}
                    destroyOnClose={true}
                    className="review-notice-detail"
                >
                    {
                        detail_loading ? <div style={{ textAlign: 'center' }}><Spin/></div> :
                            (
                                <div className="items">
                                    <Row className="item">
                                        <Col span={4}>标题：</Col>
                                        <Col span={20}>{detailInfo.title}</Col>
                                    </Row>
                                    <Row className="item">
                                        <Col span={4}>通知级别：</Col>
                                        <Col span={20}>
                                            {detailInfo.object === '1' ? '全国' : (detailInfo.object === '2' ? '省级' : (detailInfo.object === '3' ? '市级' : '队伍'))}
                                        </Col>
                                    </Row>
                                    <Row className="item">
                                        <Col span={4}>发布人：</Col>
                                        <Col span={20}>{detailInfo.vname}</Col>
                                    </Row>
                                    <Row className="item">
                                        <Col span={4}>发布时间：</Col>
                                        <Col span={20}>{detailInfo.cteate_time}</Col>
                                    </Row>
                                    <Row className="item">
                                        <Col span={4}>审核情况：</Col>
                                        {/*<Col>{detailInfo.title}</Col>*/}
                                        <Col span={20}>
                                            <Card bodyStyle={{ padding: 12 }} className="item-card"
                                                  title={'一级审核'}>
                                                {
                                                    detailInfo.one_indexno ?
                                                        (
                                                            <div>
                                                                <div>审核人：{detailInfo.one_indexno}</div>
                                                                <div>审核状态：{checkAudit(detailInfo.one_audit)}</div>
                                                                <div>审核时间：{detailInfo.one_time || '无'}</div>
                                                                {detailInfo.one_audit === '2' ?
                                                                    <div>不通过原因：{detailInfo.detail}</div> : null}
                                                            </div>
                                                        ) : '暂无审核'
                                                }
                                            </Card>
                                            {
                                                detailInfo.object === '1' ?
                                                    [
                                                        (<Card key="1" bodyStyle={{ padding: 10 }} className="item-card"
                                                               title={'二级审核'}>
                                                            {
                                                                detailInfo.two_indexno ?
                                                                    (
                                                                        <div>
                                                                            <div>审核人：{detailInfo.two_indexno}</div>
                                                                            <div>审核状态：{checkAudit(detailInfo.two_audit)}</div>
                                                                            <div>审核时间：{detailInfo.two_time || '无'}</div>
                                                                            {detailInfo.two_audit === '2' ?
                                                                                <div>不通过原因：{detailInfo.detail}</div> : null}
                                                                        </div>
                                                                    ) : '暂无审核'
                                                            }
                                                        </Card>),
                                                        (<Card key="2" bodyStyle={{ padding: 10 }} className="item-card"
                                                               title={'三级审核'}>
                                                            {
                                                                detailInfo.three_indexno ?
                                                                    (
                                                                        <div>
                                                                            <div>审核人：{detailInfo.three_indexno}</div>
                                                                            <div>审核状态：{checkAudit(detailInfo.three_audit)}</div>
                                                                            <div>审核时间：{detailInfo.three_time || '无'}</div>
                                                                            {detailInfo.three_audit === '2' ?
                                                                                <div>不通过原因：{detailInfo.detail}</div> : null}
                                                                        </div>
                                                                    ) : '暂无审核'
                                                            }
                                                        </Card>)
                                                    ] : null
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="item">
                                        <Col span={4}>内容：</Col>
                                        <Col span={20}>
                                            <div className="braft-output-content"
                                                 dangerouslySetInnerHTML={{ __html: detailInfo.content }}/>
                                        </Col>
                                    </Row>
                                    {detailInfo.images && detailInfo.images.length ? (
                                        <Row className="item">
                                            <Col span={4}>图片：</Col>
                                            <Col span={20}>
                                                {
                                                    detailInfo.images.map((img, index) => {
                                                        img = config.imgUrl + img
                                                        return (<a key={index} href={img} target="_blank"><img
                                                            className="d-img"
                                                            src={img} alt=""
                                                            key={index}/></a>)
                                                    })
                                                }
                                            </Col>
                                        </Row>
                                    ) : null}
                                    <div style={{ textAlign: 'right' }}>
                                        <Button onClick={() => this.CloseDetailModal()}>关闭</Button>
                                    </div>
                                </div>
                            )
                    }
                </Modal>
            </div>
        )
    }
}

ReNotice.propTypes = {
    successReview: PropTypes.func.isRequired,   //审核通过处理
    failReview: PropTypes.func.isRequired,  //审核失败处理
}

export default ReNotice



// WEBPACK FOOTER //
// ./src/routes/review/ReNotice.jsx